var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916667 0.176758C0.686548 0.176758 0.5 0.363306 0.5 0.593424V1.42676C0.5 1.65688 0.686548 1.84342 0.916667 1.84342H15.0833C15.3135 1.84342 15.5 1.65688 15.5 1.42676V0.593424C15.5 0.363306 15.3135 0.176758 15.0833 0.176758H0.916667ZM0.916667 4.34342C0.686548 4.34342 0.5 4.52997 0.5 4.76009V5.59342C0.5 5.82354 0.686548 6.01009 0.916667 6.01009H10.0833C10.3135 6.01009 10.5 5.82354 10.5 5.59342V4.76009C10.5 4.52997 10.3135 4.34342 10.0833 4.34342H0.916667ZM0.5 8.92676C0.5 8.69664 0.686548 8.51009 0.916667 8.51009H5.08333C5.31345 8.51009 5.5 8.69664 5.5 8.92676V9.76009C5.5 9.99021 5.31345 10.1768 5.08333 10.1768H0.916667C0.686548 10.1768 0.5 9.99021 0.5 9.76009V8.92676Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIndicator);
export default __webpack_public_path__ + "static/media/dropdownIndicator.9417f294.svg";
export { ForwardRef as ReactComponent };